module.exports = "https://static.wmbcdn.com/uniweb/images/9890e3df43a3e7ed75e9ef7a0bd17a19.svg";